import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c59fccaa&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c59fccaa')) {
      api.createRecord('c59fccaa', component.options)
    } else {
      api.reload('c59fccaa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c59fccaa&", function () {
      api.rerender('c59fccaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/provisions/index.vue"
export default component.exports